import { Typography } from '@mui/material';
import React from 'react';
import {
  DateField,
  Edit as Show,
  Labeled,
  SimpleShowLayout,
  TextField,
  useTranslate,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { TaxesArrayField } from '../contracts/TaxesArrayField';
import { QbLinesFields } from './QbLinesFields';

export const InvoiceShow = () => {
  const translate = useTranslate();

  return (
    <Show>
      <SimpleShowLayout >
        <Typography>
          {translate('resources.invoices.name', { smart_count: 1 })}
        </Typography>
        <Labeled label="resources.invoices.fields.TxnDate">
          <DateField source="TxnDate" />
        </Labeled>
        <Labeled label="resources.invoices.fields.DueDate">
          <DateField source="DueDate" />
        </Labeled>
        <QbLinesFields />

        <Labeled label="resources.invoices.fields.GlobalTaxCalculation">
          <TextField source="GlobalTaxCalculation" />
        </Labeled>
        <TaxesArrayField source="TxnTaxDetail.TaxLine" />
        <Labeled label="resources.invoices.fields.TotalAmt">
          <QuickbooksPriceField source="TotalAmt" />
        </Labeled>
        <Labeled label="resources.invoices.fields.Balance">
          <QuickbooksPriceField source="Balance" />
        </Labeled>
        <Labeled label="resources.invoices.fields.PrintStatus">
          <TextField source="PrintStatus" />
        </Labeled>
        <Labeled label="resources.invoices.fields.EmailStatus">
          <TextField source="EmailStatus" />
        </Labeled>
      </SimpleShowLayout>
    </Show>
  );
};
